
import { defineComponent } from 'vue';
import { useStore } from 'vuex';
import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalService from '@/modules/modals/services/modalService';
import AddManualComp from '@/modules/add-manual-comp/components/AddManualComp.vue';
import LogUsageManager from '@/manager/LogUsageManager';
import CompsManager from '@/manager/3.6/CompsManager';

export default defineComponent({
    components: { ModalHeader, ModalBody, ModalFooter, AddManualComp },
    data() {
        return {
            modal: null,
            addManualCompCallback: [],
        };
    },
    setup() {
        const store = useStore();
        return {
            store,
        };
    },
    mounted() {
        const modalElement = this.$refs.addManualComp;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, 'lg');
        ModalService.open(this.modal);
    },
    methods: {
        async saveComp() {
            const elForm = document.getElementById('addManualComp') as HTMLElement;
            var forms = document.querySelectorAll('.needs-validation');
            Array.prototype.filter.call(forms, function (form) {
                if (!form.checkValidity()) {
                    form.classList.add('error-validated');
                } else {
                    form.classList.remove('error-validated');
                }

                form.classList.add('was-validated');
            });

            if (!elForm.classList.contains('error-validated')) {
                await CompsManager.addManualComps(this.addManualCompCallback);

                LogUsageManager.addCompManually();

                (this as any).eventBus.emit('checkTabOverflow');

                ModalService.hide(this.modal);
            }
        },
        AddManualCompCallback(obj: any) {
            this.addManualCompCallback = obj;
        },
    },
});
